import logo from '../The other half logo.png';
import Bismillah from '../Bismillah786.png';
import React from 'react'
import "../styles.css";
import FormfacadeEmbed from "@formfacade/embed-react";

function Home() {
  return (
    <div style={{ backgroundColor: "#f6f4f0", minHeight: "100vh" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ textAlign: "center" }}>
            <img src={Bismillah} width={325} height={150} alt="Bismillah" />
        </div>
        <div style={{ textAlign: "center" }}>
            <img src={logo} width={325} height={"auto"} alt="Logo" />
        </div>
        <div className="font-container">
                <p className="montserrat">
                The Other Half Club seeks to help unmarried Muslims of every level of faith find their match by creating in-person events for curated matches to meet one another. We plan to launch in the Atlanta area in 2026. We’d like your help in creating an optimal, data driven, matching system by telling us about yourself in the following survey.
                </p>
            </div>
            <FormfacadeEmbed

formFacadeURL="https://formfacade.com/include/104356297121719412631/form/1FAIpQLSci9pUsT3I1dk8aFw9TMRaVe42_tt2Ko3DjLgTyXE6Y0gzGSw/classic.js/?div=ff-compose"

onSubmitForm={() => console.log('Form submitted')}

/>

    </div>
    
    </div>
  )
}

export default Home